import React from 'react'
import Field from '../../common/Field'
import Validator from '../../common/Validator'
import Reflux from 'reflux'
import Store from '../../../store/store'
import moment from 'moment'
import 'moment/locale/hu'
import 'react-datepicker/dist/react-datepicker.css'
import i18 from '../../../i18'
import api from '../../../source/api'
import NotificationSystem from 'react-notification-system'
import DatePicker from 'react-date-picker';


class Upload extends Reflux.Component {

    constructor(props) {
        super(props)
        this._notificationSystem = null
        this.state = {
            userconfigs: props.userconfigs,
            company: props.company,
            processing: false,
            onlineszamlaToken: props.onlineszamlaToken,
            customerRules: props.customerRules,
            fields: {
                date_type: {value: 'issue', error: '', role: {required: true}},
                registration_number_of_cash_huf: {value: '', error: '', role: {required: true}},
                registration_number_of_cash_foreign: {value: '', error: '', role: {required: true}},
                registration_number_of_transfer_huf: {value: '', error: '', role: {required: true}},
                registration_number_of_transfer_foreign: {value: '', error: '', role: {required: true}},
                registration_number_of_card_huf: {value: '', error: '', role: {required: true}},
                registration_number_of_card_foreign: {value: '', error: '', role: {required: true}},
                registration_number_of_voucher_huf: {value: '', error: '', role: {required: true}},
                registration_number_of_voucher_foreign: {value: '', error: '', role: {required: true}},
                registration_number_of_other_huf: {value: '', error: '', role: {required: true}},
                registration_number_of_other_foreign: {value: '', error: '', role: {required: true}},

                export_date_type: {value: 'DELIVERY_DATE', error: '', role: {required: true}},
                invoice_number_rule: {value: 'DISABLED', error: '', role: {required: true}},
                job_number: {value: '', error: '', role: {required: false}},
                navXml: {value: '', error: '', role: {required: true}},
            },
            startDate: new Date(),
            endDate: new Date(),
            date: {
                error: ''
            }
        }
        this.store = Store
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);

    }

    componentDidMount = () => {
        moment.locale('hu')
        this._notificationSystem = this.refs.notificationSystem
        window.scrollTo(0, 0)
    }

    _addNotification = (msg, type, time = 30) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    handleStartDateChange = (date) => {
        this.setState({startDate: date});
    }

    handleEndDateChange = (date) => {
        this.setState({endDate: date});
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        let fields = this.state.fields;
        let startDate = new Date();
        let endDate = new Date();

        if (nextProps.userconfigs && Object.keys(nextProps.userconfigs).length > 0) {

            fields.date_type.value = nextProps.userconfigs.date_type || 'issue';
            fields.registration_number_of_cash_huf.value = nextProps.userconfigs.cash_huf_invoices_code;
            fields.registration_number_of_cash_foreign.value = nextProps.userconfigs.cash_foreign_currency_invoices_code;
            fields.registration_number_of_transfer_huf.value = nextProps.userconfigs.transfer_huf_invoices_code;
            fields.registration_number_of_transfer_foreign.value = nextProps.userconfigs.transfer_foreign_invoices_code;
            fields.registration_number_of_card_huf.value = nextProps.userconfigs.registrationNumberOfHufBankCardTransaction;
            fields.registration_number_of_card_foreign.value = nextProps.userconfigs.registrationNumberOfBankCardTransaction;
            fields.registration_number_of_voucher_huf.value = nextProps.userconfigs.registration_number_of_voucher_huf;
            fields.registration_number_of_voucher_foreign.value = nextProps.userconfigs.registration_number_of_voucher_foreign;
            fields.registration_number_of_other_huf.value = nextProps.userconfigs.registration_number_of_other_huf;
            fields.registration_number_of_other_foreign.value = nextProps.userconfigs.registration_number_of_other_foreign;

            fields.export_date_type.value = nextProps.userconfigs.export_date_type;
            fields.invoice_number_rule.value = nextProps.userconfigs.invoice_number_rule;
            fields.job_number.value = nextProps.userconfigs.job_number || '';

            startDate = new Date(nextProps.userconfigs.start_date);
            endDate = new Date(nextProps.userconfigs.end_date);
        }

        this.setState({
            fields: fields,
            userconfigs: nextProps.userconfigs,
            company: nextProps.company,
            onlineszamlaToken: nextProps.onlineszamlaToken,
            customerRules: nextProps.customerRules,
            startDate: startDate,
            endDate: endDate,
        })
    }

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value
        fields[name].error = error
        this.setState({fileds: fields});
    }

    nextStep = (useApi) => {
        let self = this;
        document.body.classList.toggle('loading-body', true)
        this.setState({processing: true});

        let fields = this.state.fields;
        fields.navXml.role.required = !useApi;
        let validator = Validator.validate(fields)

        if (validator.error) {
            this.setState({
                error: validator.error,
                fields: validator.fields,
                processing: false,
            });
            document.body.classList.remove('loading-body')
            return;
        }

        let form = this.buildSubmitForm(useApi)

        api.postFile({url: 'customer/steps/upload', data: form}, true)
            .then((response) => {
                if (response.data.outOfRange > 0) {
                    alert(response.data.outOfRange + ' számla kívül esik a dátum intervallumon!', 'error');
                }
                this.props.updateConfig(response.data.config);
                this.props.updateInvoices(response.data.invoices, this.state.customerRules);
                this.props.nextStep();
            })
            .catch((err) => {
                console.log(err);
                this._addNotification(err.response ? err.response.data.error.message : 'Hiba', 'error');
            })
            .finally(function () {
                document.body.classList.remove('loading-body')
                self.setState({processing: false});
            });
    }

    buildSubmitForm = (useApi) => {
        let form = new FormData()
        if (!useApi) {
            form.append('inputFile', document.querySelector('#navXml').files[0])
        }

        form.append('date_type', this.state.fields.date_type.value);
        form.append('startDate', moment(this.state.startDate).format('YYYY-MM-DD'))
        form.append('endDate', moment(this.state.endDate).format('YYYY-MM-DD'))
        form.append('company_id', this.state.company.id)
        form.append('registration_number_of_cash_huf', this.state.fields.registration_number_of_cash_huf.value)
        form.append('registration_number_of_cash_foreign', this.state.fields.registration_number_of_cash_foreign.value)
        form.append('registration_number_of_transfer_huf', this.state.fields.registration_number_of_transfer_huf.value)
        form.append('registration_number_of_transfer_foreign', this.state.fields.registration_number_of_transfer_foreign.value)
        form.append('registration_number_of_card_huf', this.state.fields.registration_number_of_card_huf.value)
        form.append('registration_number_of_card_foreign', this.state.fields.registration_number_of_card_foreign.value)
        form.append('registration_number_of_voucher_huf', this.state.fields.registration_number_of_voucher_huf.value)
        form.append('registration_number_of_voucher_foreign', this.state.fields.registration_number_of_voucher_foreign.value)
        form.append('registration_number_of_other_huf', this.state.fields.registration_number_of_other_huf.value)
        form.append('registration_number_of_other_foreign', this.state.fields.registration_number_of_other_foreign.value)
        form.append('export_date_type', this.state.fields.export_date_type.value)
        form.append('invoice_number_rule', this.state.fields.invoice_number_rule.value)
        form.append('job_number', this.state.fields.job_number.value)
        form.append('useApi', useApi ? 1 : 0)
        return form
    }

    onChangeSelect = (event) => {
        let fields = this.state.fields;
        fields[event.target.name].value = event.target.value;
        this.setState({fields: fields})
    }

    render() {
        return (
            <div className='row'>
                <div className='col-md-10 offset-md-1'>
                    <div className='row'>
                        <div className='col-3 offset-3'>
                            <select value={this.state.fields.date_type.value}
                                    name='date_type'
                                    onChange={(event) => this.onChangeSelect(event)}
                                    className='minimal-100  form-control'>
                                <option value='issue'>Kiállítás alapján</option>
                                <option value='delivery'>Teljesítés alapján</option>
                            </select>
                        </div>
                        <div className='col-3'>
                            <DatePicker
                                className="date-picker"
                                required={true}
                                locale="hu-HU"
                                onChange={this.handleStartDateChange}
                                value={this.state.startDate}
                            />
                        </div>
                        <div className='col-3'>
                            <DatePicker
                                className="date-picker"
                                locale="hu-HU"
                                onChange={this.handleEndDateChange}
                                value={this.state.endDate}
                            />
                        </div>
                    </div>
                    {this.state.date.error
                        ? <div className='row'>
                            <div className='col-md-6 offset-md-3'>
                                <p className='help-block help-block-error'>
                                    <span className='error'><i className='fa fa-warning'/> {this.state.date.error}</span>
                                </p>
                            </div>
                        </div>
                        : null
                    }
                    <table className='table table-striped  table-aibook-bordered'>
                        <thead>
                        <tr>
                            <th style={{width: '50%'}}>Fizetés típusa</th>
                            <th style={{width: '25%'}}>Forintos</th>
                            <th style={{width: '25%'}}>Devizás</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>KÉSZPÉNZES SZÁMLÁK RÖGZÍTÉSE</td>
                            <td className='text-center'>
                                <Field
                                    type='text'
                                    id='registration_number_of_cash_huf'
                                    name='registration_number_of_cash_huf'
                                    label=''
                                    classLabel='control-label'
                                    classInput='bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </td>
                            <td className='text-center'>
                                <Field
                                    type='text'
                                    id='registration_number_of_cash_foreign'
                                    name='registration_number_of_cash_foreign'
                                    label=''
                                    classLabel='control-label'
                                    classInput='bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>ÁTUTALÁSOS SZÁMLÁK RÖGZÍTÉSE</td>
                            <td className='text-center'>
                                <Field
                                    type='text'
                                    id='registration_number_of_transfer_huf'
                                    name='registration_number_of_transfer_huf'
                                    label=''
                                    classLabel='control-label'
                                    classInput='bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </td>
                            <td className='text-center'>
                                <Field
                                    type='text'
                                    id='registration_number_of_transfer_foreign'
                                    name='registration_number_of_transfer_foreign'
                                    label=''
                                    classLabel='control-label'
                                    classInput='bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>BANKKÁRTYÁS SZÁMLÁK RÖGZÍTÉSE</td>
                            <td className='text-center'>
                                <Field
                                    type='text'
                                    id='registration_number_of_card_huf'
                                    name='registration_number_of_card_huf'
                                    label=''
                                    classLabel='control-label'
                                    classInput='bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </td>
                            <td className='text-center'>
                                <Field
                                    type='text'
                                    id='registration_number_of_card_foreign'
                                    name='registration_number_of_card_foreign'
                                    label=''
                                    classLabel='control-label'
                                    classInput='bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>UTALVÁNYOS SZÁMLÁK RÖGZÍTÉSE</td>
                            <td className='text-center'>
                                <Field
                                    type='text'
                                    id='registration_number_of_voucher_huf'
                                    name='registration_number_of_voucher_huf'
                                    label=''
                                    classLabel='control-label'
                                    classInput='bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </td>
                            <td className='text-center'>
                                <Field
                                    type='text'
                                    id='registration_number_of_voucher_foreign'
                                    name='registration_number_of_voucher_foreign'
                                    label=''
                                    classLabel='control-label'
                                    classInput='bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>EGYÉB SZÁMLÁK RÖGZÍTÉSE</td>
                            <td className='text-center'>
                                <Field
                                    type='text'
                                    id='registration_number_of_other_huf'
                                    name='registration_number_of_other_huf'
                                    label=''
                                    classLabel='control-label'
                                    classInput='bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </td>
                            <td className='text-center'>
                                <Field
                                    type='text'
                                    id='registration_number_of_other_foreign'
                                    name='registration_number_of_other_foreign'
                                    label=''
                                    classLabel='control-label'
                                    classInput='bordered-input'
                                    setValue={this.setValue.bind(this)}
                                    state={this.state}
                                    style={{width: '100%'}}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Exportban szereplő dátum érték
                            </td>
                            <td colSpan='2' className='text-center'>
                                <select value={this.state.fields.export_date_type.value}
                                        name='export_date_type'
                                        onChange={(event) => this.onChangeSelect(event)}
                                        className='minimal-100  form-control'>
                                    <option value='DELIVERY_DATE'>Teljesítés dátuma</option>
                                    <option value='ISSUE_DATE'>Kelte dátuma</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Szabály létrehozása bizonylatszámra
                            </td>
                            <td colSpan='2' className='text-center'>
                                <select value={this.state.fields.invoice_number_rule.value}
                                        name='invoice_number_rule'
                                        onChange={(event) => this.onChangeSelect(event)}
                                        className='minimal-100  form-control'>
                                    <option value='DISABLED'>Nincs engedélyezve</option>
                                    <option value='ENABLED'>Engedélyezve</option>
                                </select>
                            </td>
                        </tr>
                        {this.state.company && this.state.company.accountant_program_id === 3
                            ? <tr>
                                <td>Munkaszám</td>
                                <td colSpan="2" className="text-right">
                                    <Field
                                        type='text'
                                        id='job_number'
                                        name='job_number'
                                        label=''
                                        classLabel='control-label'
                                        classInput='bordered-input'
                                        setValue={this.setValue.bind(this)}
                                        state={this.state}
                                        style={{width: '100%'}}
                                    />
                                </td>
                            </tr>
                            : null}
                        </tbody>
                    </table>
                    <div className='row'>
                        <div className='col-6 text-center'>
                            <p>XML file alapú számla feldolgozás</p>
                            <Field
                                type='file'
                                id='navXml'
                                name='navXml'
                                fileUploadEndpoint=''
                                classLabel='control-label'
                                classInput='file-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '350px', margin: 'auto'}}
                            />
                            <div className='next-step-btn-container'>
                                <a onClick={() => this.nextStep(false)} className={this.state.processing ? 'disabled next-step' : 'next-step'}>{this.state.processing ? i18.BUTTONS._processing : i18.BUTTONS._goToAccountAssignment}</a>
                            </div>
                        </div>
                        <div className='col-6 text-center'>
                            <p>API alapú számla feldolgozás</p>
                            <br/>
                            <div className='next-step-btn-container'>
                                {this.state.onlineszamlaToken
                                    ? <a onClick={() => this.nextStep(true)} className='next-step'>{this.state.processing ? i18.BUTTONS._processing : i18.BUTTONS._goToAccountAssignment}</a>
                                    : <a className='disabled next-step'>{this.state.processing ? i18.BUTTONS._processing : i18.BUTTONS._goToAccountAssignment}</a>
                                }

                            </div>
                        </div>
                    </div>
                    <NotificationSystem ref='notificationSystem'/>
                </div>
            </div>
        )
    }
}

export default Upload


// WEBPACK FOOTER //
// ./src/components/customer/steps/upload.js